import { toast } from "@luce/ui";

import { getErrorMessage } from "../string";

export async function copyClipboard(msg: string) {
  try {
    if (msg) {
      await navigator.clipboard.writeText(msg).then(() => {
        toast.success("Copied to clipboard");
      });
    } else {
      throw new Error("Failed to copy clipboard");
    }
  } catch (error) {
    const errMsg = getErrorMessage(error, "Error copy clipboard");
    toast.error(errMsg);
  }
}
